module.exports = __webpack_public_path__ + "media/images/musician_finder-995fe457f0326451056d016c58b86477.jpeg";